module.exports = __webpack_public_path__ + "img/Speaker=Jeff Nguyen.53823f25.png";